var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24350",
    "data-name": "Group 24350",
    transform: "translate(-643 -679)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20092",
    "data-name": "Rectangle 20092",
    className: "cls-1",
    width: 18,
    height: 18,
    transform: "translate(643 679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17779",
    "data-name": "Path 17779",
    className: "cls-2",
    d: "M9,6.333V9l2,2m4-2A6,6,0,1,1,9,3a6,6,0,0,1,6,6Z",
    transform: "translate(643 679)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime2);
export default __webpack_public_path__ + "static/media/time2.6f67669e3e2af89b772f0c8cc7c0c420.svg";
export { ForwardRef as ReactComponent };